import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { BANNERS_SCHEMA } from '../schemas';

import {
  ACTION_ADD_BANNERS,
  ACTION_LOAD_BANNERS__REQUEST,
  ACTION_LOAD_BANNERS__SUCCESS,
  ACTION_LOAD_BANNERS__FAIL,
  ACTION_BANNER__REQUEST,
  ACTION_BANNER__SUCCESS,
  ACTION_BANNER__FAIL,
  ACTION_DELETE_BANNER__REQUEST,
  ACTION_DELETE_BANNER__SUCCESS,
  ACTION_DELETE_BANNER__FAIL,
} from '../actionTypes';
import { MODAL_DIALOG__EDIT_BANNER } from '../constants/dialogs';

import { getModalDataByName } from 'react-redux-app/lib/modules/modal/selectors';

import { addId } from 'react-redux-app/lib/modules/api/utils';


export const actionAddBanners = banners => ({
  type: ACTION_ADD_BANNERS,
  payload: { banners },
});

export const actionLoadBannersSuccess = () => ({
  type: ACTION_LOAD_BANNERS__SUCCESS,
});

export const actionLoadBannersFail = error => ({
  type: ACTION_LOAD_BANNERS__FAIL,
  payload: { error },
});

export const actionLoadBannersRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_BANNERS__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/site_banner',
      {},
      BANNERS_SCHEMA
    ).then(
      ({ entities }) => {
        dispatch(actionAddBanners(entities.banners));

        dispatch(actionLoadBannersSuccess());
      },
      error => {
        dispatch(actionLoadBannersFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

// TODO osigum rename
const actionBannerSuccess = banner => ({
  type: ACTION_BANNER__SUCCESS,
  payload: { banner },
});

const actionBannerFail = error => ({
  type: ACTION_BANNER__FAIL,
  payload: { error },
});

export const actionCreateBannerImageRequest = (name, link, file) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    const formData = new FormData();
    if (name) {
      formData.append('name', name);
    }
    if (link) {
      formData.append('link', link);
    }
    if (file) {
      formData.append('file', file[0]);
    }

    return apiClientHelper.post(
      '/rest/webmaster/site_banner/image',
      { data: formData, file: true }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionCreateBannerHtmlRequest = (name, html) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/site_banner/html',
      { data: { name, html } }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionCreateBannerTextLinkRequest = (name, link, title, description) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/site_banner/textlink',
      {
        data: {
          name,
          link,
          title,
          description,
        },
      }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionEditBannerImageRequest = (name, link, file) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    const { id } = getModalDataByName(getState(), MODAL_DIALOG__EDIT_BANNER);

    const formData = new FormData();
    formData.append('id', id);
    formData.append('name', name);
    formData.append('link', link);
    if (file) {
      formData.append('file', file[0]);
    }

    return apiClientHelper.put(
      `/rest/webmaster/site_banner/image/${id}`,
      { data: formData, file: true }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionEditBannerHtmlRequest = (name, html) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    const { id } = getModalDataByName(getState(), MODAL_DIALOG__EDIT_BANNER);

    return apiClientHelper.put(
      `/rest/webmaster/site_banner/html/${id}`,
      { data: { name, html } }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionEditBannerTextLinkRequest = (name, link, title, description) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_BANNER__REQUEST,
    });

    const { id } = getModalDataByName(getState(), MODAL_DIALOG__EDIT_BANNER);

    return apiClientHelper.put(
      `/rest/webmaster/site_banner/textlink/${id}`,
      {
        data: {
          name,
          link,
          title,
          description,
        },
      }
    ).then(
      result => {
        dispatch(actionBannerSuccess(result));
      },
      error => {
        dispatch(actionBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionDeleteBannerSuccess = bannerId => ({
  type: ACTION_DELETE_BANNER__SUCCESS,
  payload: { bannerId },
});

const actionDeleteBannerFail = (bannerId, error) => ({
  type: ACTION_DELETE_BANNER__FAIL,
  payload: { bannerId, error },
});

export const actionDeleteBannerRequest = bannerId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_DELETE_BANNER__REQUEST,
      payload: { bannerId },
    });

    return apiClientHelper.del(
      `/rest/webmaster/site_banner/${bannerId}`
    ).then(
      () => {
        dispatch(actionDeleteBannerSuccess(bannerId));
      },
      error => {
        dispatch(actionDeleteBannerFail(bannerId, addId(error, bannerId)));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
